import { type CSSProperties } from 'react';

/** css value가 number로만 되어 있을 경우 뒤에 `px`을 붙여준다 */
export const convertToCssPixelValue = (value: CSSProperties['top']) =>
  `${typeof value === 'number' ? `${value}px` : value}`;
